import { render } from "preact";
import { registerSW } from "virtual:pwa-register";
import { probeOpenServer, setOpenServer } from "./api";
import { App } from "./App";
import { completeSignIn, storedTokens } from "./auth";
import "./styles.css";

async function start(): Promise<void> {
  let signInError: string | null = null;
  if (location.pathname === "/auth") {
    try {
      const to = await completeSignIn(new URLSearchParams(location.search));
      history.replaceState({ depth: 0 }, "", to);
    } catch (e) {
      signInError = e instanceof Error ? e.message : String(e);
      history.replaceState({ depth: 0 }, "", "/");
    }
  }
  // Without tokens, a local server with AUTH_MODE=none answers /api/me openly: no sign-in then.
  const open = !storedTokens() && (await probeOpenServer());
  setOpenServer(open);
  render(<App open={open} signedIn={open || storedTokens() !== null} signInError={signInError} />, document.getElementById("app")!);
}

start();

// A new version is installed in the background and taken into use on the next start (or now, on the prompt).
const updateSW = registerSW({
  onNeedRefresh() {
    const bar = document.createElement("button");
    bar.className = "update-bar";
    bar.textContent = "A new version is available. Tap to reload.";
    bar.onclick = () => updateSW(true);
    document.body.appendChild(bar);
  },
});
